export default function Logo({ className = "h-12 sm:h-14" }) {
  return (
    <img
      src="/aplus-logo.jpg"
      alt="A+ Detailing & Tint logo"
      className={`w-auto ${className}`}
      data-testid="brand-logo"
    />
  );
}
